import type Hotspot from '@/types/Hotspot'
import { Html } from '@react-three/drei'
import * as THREE from 'three'
import './hotspotButton.css'
import { useVideo } from '@/context/VideoContext'

type HotspotButtonProps = {
  data: Hotspot
  onClick: () => void
}

export default function HotspotButton({ data, onClick }: HotspotButtonProps) {
  if (!data || !data.position) {
    return null
  }

  const { isPlaying } = useVideo()

  if (isPlaying) {
    return null
  }

  // Convert the position array to a Vector3
  const positionVector = new THREE.Vector3(...data.position)

  // Normalise the position to ensure it's on the sphere surface
  // and multiply to the radius (slightly smaller than the video sphere to be visible)
  const normalizedPosition = positionVector.multiplyScalar(490)

  return (
    <Html position={normalizedPosition} zIndexRange={[40, 0]} center occlude style={{ pointerEvents: 'none' }}>
      <button
        type="button"
        className="hotspot-button"
        style={{ pointerEvents: 'auto' }}
        onClick={(e) => {
          e.stopPropagation()
          console.log(`Hotspot clicked: ${data.id}`, 'navigation')
          onClick()
        }}
        aria-label="Hotspot"
      />
    </Html>
  )
}

export { HotspotButton }
/* eslint-disable jsx-a11y/click-events-have-key-events */
